module.exports = __webpack_public_path__ + "static/media/yiyuan5.5754f81a.png";